export default {
  admin: {
    products: {
      holdingData: {
        deleteDataSingleDate: {
          button: "Eliminar",
          deleteSuccessText: "Os dados da carteira foram eliminados com sucesso.",
          prompt: {
            delete: "Eliminar",
            text: (ctx) =>
              `Está prestes a eliminar permanentemente os dados da carteira para ${ctx.named("date")}. Se tem a certeza, clique no botão abaixo para confirmar.`,
            title: "Eliminar dados da carteira",
          },
        },
        deletePropertyMetadata: {
          deleteSuccessText: "A propriedade foi eliminada com sucesso.",
          prompt: {
            cancel: "Cancelar",
            delete: "Eliminar",
            deleteForDate: (ctx) => `Para a data ${ctx.named("selectedDate")}`,
            deleteGlobally: "Eliminar globalmente",
            text: (ctx) =>
              `Está prestes a eliminar a propriedade "${ctx.named("propertyToDelete")}". Deseja eliminá-la globalmente ou apenas para esta data?`,
            title: "Eliminar propriedade",
          },
        },
        enrichDataSingleDate: {
          button: "Enriquecer a partir de CSV",
          enrichSuccessText: "Os dados da carteira foram enriquecidos com sucesso.",
          emptyCsv: "Nada para importar — o ficheiro CSV está vazio.",
          noPropertyToEnrich:
            "Não foi encontrada nenhuma propriedade definida pelo utilizador para enriquecer os dados atuais.",
          enrichPrompt: {
            cancel: "Cancelar",
            condition1:
              "O ficheiro deve conter uma linha de cabeçalho com, pelo menos: 'Holding name', 'Isin', 'Currency' e uma propriedade adicional definida pelo utilizador.",
            condition2:
              "Cada linha deve ter uma combinação única de 'Holding name', 'Isin' e 'Currency'.",
            condition3:
              "Cada combinação de 'Holding name', 'Isin' e 'Currency' para a data alvo deve aparecer exatamente uma vez no CSV.",
            enrich: "Enriquecer",
            text: "Carregue um ficheiro CSV para enriquecer os dados da carteira. As seguintes condições devem ser cumpridas:",
            title: "Enriquecer dados da carteira",
          },
          enrichNewPropertyPrompt: {
            cancel: "Cancelar",
            enrich: "Enriquecer",
            isCategorical: "Categórico",
            isCategoricalTooltip:
              "Propriedades categóricas permitem agrupar as posições em seções como 'Visão Geral' e 'Ficha Técnica', em uma data específica ou ao longo do tempo. Estas propriedades podem ser traduzidas na seção de Ajuste de Dados da Posição. Se uma propriedade categórica for gerada automaticamente (e não inserida manualmente pelo usuário), ela também pode ser sobrescrita nessa mesma seção.",
            isFfill: "Preenchimento progressivo",
            isFfillTooltip:
              "Se não houver valor disponível para a data selecionada, será utilizado o valor mais recente disponível antes dessa data.",
            newProperty: "Nova propriedade",
            text: "Este enriquecimento criará novas propriedades. Por favor, reveja as propriedades propostas e defina seus parâmetros padrão. Observação: mesmo pequenas diferenças no nome (como diferenciação entre maiúsculas e minúsculas) resultarão na criação de uma nova propriedade.",
            title: "Novas propriedades detectadas",
          },
          enrichErrorPrompt: {
            close: "Fechar",
            selectErrorType: "Selecionar tipo de erro:",
            title: "Erros de enriquecimento",
            columns: {
              currency: "Moeda",
              firstRow: "Primeira linha",
              holdingName: "Nome da posição",
              isin: "ISIN",
              rowIndex: "Índice da linha",
            },
            duplicatedHeader: {
              header: "Cabeçalhos duplicados:",
              title: "Cabeçalho duplicado",
              text: "O seu ficheiro CSV contém cabeçalhos de coluna duplicados. Por favor, renomeie-os para que cada cabeçalho seja único.",
            },
            emptyHeader: {
              title: "Cabeçalho vazio",
              text: "O seu ficheiro CSV contém cabeçalhos de coluna vazios. Por favor, atribua um nome a cada coluna utilizando pelo menos um carácter não vazio.",
            },
            mismatchedColumn: {
              missingExpectedColumns: "Colunas obrigatórias em falta:",
              title: "Incompatibilidade de colunas",
              text: "Certifique-se de que o cabeçalho do CSV inclui (sensível a maiúsculas/minúsculas): Holding name, Isin, Currency.",
            },
            duplicatedConstituent: {
              title: "Posição duplicada",
              text: "Remova entradas duplicadas para a mesma posição.",
            },
            missingConstituent: {
              title: "Posição em falta",
              text: "Adicione as posições em falta para garantir que o CSV cobre completamente a data selecionada.",
            },
            papaparseMissingQuotes: {
              title: "Aspas não fechadas",
              text: "A análise do CSV falhou porque uma cadeia de texto entre aspas não foi devidamente fechada. Verifique se há aspas de fechamento ausentes nos seus dados.",
            },
            papaparseUndetectableDelimiter: {
              title: "Delimitador indetectável",
              text: "A análise do CSV falhou. Nenhum delimitador comum foi detectado. Certifique-se de que o seu arquivo utiliza apenas um tipo de delimitador, geralmente uma vírgula ou ponto e vírgula.",
            },
            papaparseTooFewFields: {
              title: "Campos insuficientes",
              text: "A análise do CSV falhou. Cada linha deve ter o mesmo número de colunas que o cabeçalho. Atualmente, algumas linhas têm menos colunas do que o esperado. Verifique a estrutura do seu arquivo.",
            },
            papaparseTooManyFields: {
              title: "Campos em excesso",
              text: "A análise do CSV falhou. Cada linha deve ter o mesmo número de colunas que o cabeçalho. Atualmente, algumas linhas têm mais colunas do que o esperado. Verifique a estrutura do seu arquivo.",
            },
          },
        },
        exportDataSingleDate: {
          button: "Exportar como CSV",
        },
        importDataSingleDate: {
          button: "Importar de CSV",
          emptyCsv: "Nada para importar — o ficheiro CSV está vazio.",
          importSuccessText: "Os dados da carteira foram importados com sucesso.",
          importPrompt: {
            cancel: "Cancelar",
            condition1:
              "O ficheiro deve conter uma linha de cabeçalho com, pelo menos: 'Holding name', 'Isin', 'Currency', 'value' e 'weight'.",
            condition2:
              "Cada linha deve ter uma combinação única de 'Holding name', 'Isin' e 'Currency'.",
            condition3:
              "Cada 'value' e 'weight' deve ser um número com formato padrão (ponto como separador decimal, sem separador de milhar).",
            date: "Data",
            import: "Importar",
            text: "Carregue um ficheiro CSV para importar dados da carteira. As seguintes condições devem ser cumpridas:",
            title: "Importar dados da carteira",
          },
          importNewPropertyPrompt: {
            cancel: "Cancelar",
            import: "Importar",
            isCategorical: "Categórico",
            isCategoricalTooltip:
              "Propriedades categóricas permitem agrupar as posições em seções como 'Visão Geral' e 'Ficha Técnica', em uma data específica ou ao longo do tempo. Estas propriedades podem ser traduzidas na seção de Ajuste de Dados da Posição. Se uma propriedade categórica for gerada automaticamente (e não inserida manualmente pelo usuário), ela também pode ser sobrescrita nessa mesma seção.",
            isFfill: "Preenchimento progressivo",
            isFfillTooltip:
              "Se não houver valor disponível para a data selecionada, será utilizado o valor mais recente disponível antes dessa data.",
            newProperty: "Nova propriedade",
            text: "Esta importação criará novas propriedades. Por favor, reveja as propriedades propostas e defina seus parâmetros padrão. Observação: mesmo pequenas diferenças no nome (como diferenciação entre maiúsculas e minúsculas) resultarão na criação de uma nova propriedade.",
            title: "Novas propriedades detectadas",
          },
          importErrorsPrompt: {
            close: "Fechar",
            selectErrorType: "Selecionar tipo de erro:",
            title: "Erros de importação",
            columns: {
              currency: "Moeda",
              firstRow: "Primeira linha",
              holdingName: "Nome da posição",
              isin: "ISIN",
              rowIndex: "Índice da linha",
            },
            duplicatedHeader: {
              header: "Cabeçalhos duplicados:",
              title: "Cabeçalho duplicado",
              text: "O seu ficheiro CSV contém cabeçalhos de coluna duplicados. Por favor, renomeie-os para que cada cabeçalho seja único.",
            },
            emptyHeader: {
              title: "Cabeçalho vazio",
              text: "O seu ficheiro CSV contém cabeçalhos de coluna vazios. Por favor, atribua um nome a cada coluna utilizando pelo menos um carácter não vazio.",
            },
            mismatchedColumn: {
              missingExpectedColumns: "Colunas obrigatórias em falta:",
              title: "Incompatibilidade de colunas",
              text: "Certifique-se de que o cabeçalho do CSV inclui (sensível a maiúsculas/minúsculas): Holding name, Isin, Currency, value, weight.",
            },
            duplicatedConstituent: {
              title: "Posição duplicada",
              text: "Remova entradas duplicadas para a mesma posição.",
            },
            missingValue: {
              title: "Valor em falta",
              text: "Algumas linhas não têm valor. Certifique-se de que todas as linhas têm um valor numérico corretamente formatado.",
            },
            invalidValueFormat: {
              title: "Formato de valor inválido",
              text: "O formato da coluna 'value' não pôde ser reconhecido. Use ponto como separador decimal e não utilize separador de milhar.",
            },
            missingWeight: {
              title: "Peso em falta",
              text: "Algumas linhas não têm peso. Certifique-se de que todas as linhas têm um peso numérico corretamente formatado.",
            },
            invalidWeightFormat: {
              title: "Formato de peso inválido",
              text: "O formato da coluna 'weight' não pôde ser reconhecido. Use ponto como separador decimal e não utilize separador de milhar.",
            },
            papaparseMissingQuotes: {
              title: "Aspas não fechadas",
              text: "A análise do CSV falhou porque uma cadeia de texto entre aspas não foi devidamente fechada. Verifique se há aspas de fechamento ausentes nos seus dados.",
            },
            papaparseUndetectableDelimiter: {
              title: "Delimitador indetectável",
              text: "A análise do CSV falhou. Nenhum delimitador comum foi detectado. Certifique-se de que o seu arquivo utiliza apenas um tipo de delimitador, geralmente uma vírgula ou ponto e vírgula.",
            },
            papaparseTooFewFields: {
              title: "Campos insuficientes",
              text: "A análise do CSV falhou. Cada linha deve ter o mesmo número de colunas que o cabeçalho. Atualmente, algumas linhas têm menos colunas do que o esperado. Verifique a estrutura do seu arquivo.",
            },
            papaparseTooManyFields: {
              title: "Campos em excesso",
              text: "A análise do CSV falhou. Cada linha deve ter o mesmo número de colunas que o cabeçalho. Atualmente, algumas linhas têm mais colunas do que o esperado. Verifique a estrutura do seu arquivo.",
            },
          },
        },
        updatePropertyMetadata: {
          saveSuccessText: "A propriedade foi atualizada com sucesso.",
          unsavedChangesAlert:
            "Tem alterações por guardar. Se sair agora, essas alterações serão perdidas.",
          prompt: {
            isCategorical: "Categórico",
            isCategoricalTooltip:
              "Propriedades categóricas permitem agrupar as posições em seções como 'Visão Geral' e 'Ficha Técnica', em uma data específica ou ao longo do tempo. Estas propriedades podem ser traduzidas na seção de Ajuste de Dados da Posição. Se uma propriedade categórica for gerada automaticamente (e não inserida manualmente pelo usuário), ela também pode ser sobrescrita nessa mesma seção.",
            isFfill: "Preenchimento progressivo",
            isFfillTooltip:
              "Se não houver valor disponível para a data selecionada, será utilizado o valor mais recente disponível antes dessa data.",
            propertyForUrl: "Propriedade de URL",
            propertyForUrlTooltip:
              "Indique o nome da propriedade que contém o URL. O valor desta propriedade será utilizado como texto clicável.",
            title: "Atualizar propriedade",
            translation: "Tradução",
          },
        },
      },
    },
  },
  auth: {
    resetPasswordLink: {
      forgotPassword: "Esqueceu sua senha?",
    },
  },
  cards: {
    needLoginCard: {
      needLogged: "Você precisa estar logado para ver este conteúdo.",
    },
  },
  compliance: {
    cookies: {
      buttonText: "Aceitar",
      cookiesUsage:
        "Este site utiliza Cookies para melhorar a usabilidade. Ao utilizar este site, você declara seu consentimento para o uso de Cookies, bem como com a política de privacidade onde você pode encontrar mais informações sobre Cookies. Link: {0}.",
      privacyPolicy: "Política de privacidade",
    },
  },
  components: {
    biggestDrawdownsTable: {
      rank: "Classificação",
      startDate: "Data de início",
      troughDate: "Data de depressão",
      recoveryDate: "Data de recuperação",
    },
    stressTestScenariosTable: {
      scenario: "Cenário",
      period: "Período",
      scenarioExtremelyBad: "Extremamente desfavorável",
      scenarioUnfavourable: "Desfavorável",
      scenarioModerate: "Moderado",
      scenarioFavourable: "Favorável",
    },
    liquidityRiskScenarioTable: {
      timeToLiquidate: "Prazo de liquidação",
      timeBucket1Day: "0-1 dia",
      timeBucket2To7Days: "2-7 dias",
      timeBucket8To30Days: "8-30 dias",
      timeBucket31To90Days: "31-90 dias",
      timeBucket91To180Days: "91-180 dias",
      timeBucket181To365Days: "181-365 dias",
      timeBucketMoreThan365Days: ">365 dias",
      waterfallCumulativeWeight: "Cascata peso cumulativo",
      proRataCumulativeWeight: "Proporcional peso cumulativo",
      nearProportionalCumulativeWeight: "Quase proporcional peso cumulativo",
    },
    details: {
      report: {
        aumFormat: (ctx) =>
          `${ctx.named("currency")} ${ctx.named("aumFormatted")} ${ctx.named("aum") > 1000000 ? "milhão" : "milhões"}${
            ctx.named("asOfDate") ? ` (em ${ctx.named("asOfDate")})` : ""
          }`,
        lastPrice: (ctx) => `${ctx.named("currency")} ${ctx.named("lastPrice")}`,
      },
      overview: {
        aumFormat: (ctx) =>
          `${ctx.named("currency")} ${ctx.named("aumFormatted")} ${ctx.named("aum") > 1000000 ? "milhão" : "milhões"} (em ${ctx.named("asOfDate")})`,
        lastPrice: (ctx) =>
          `${ctx.named("currency")} ${ctx.named("lastPrice")} (em ${ctx.named("asOfDate")})`,
      },
    },
    returnsVarGraph: {
      dailyReturn: "Retorno diário",
      twoWeekReturn: "Retorno 2 semanas",
      monthlyReturn: "Retorno mensal",
      oneDayOnePercent: "VaR 1 dia (99%)",
      oneDayFivePercent: "VaR 1 dia (95%)",
      twoWeeksOnePercent: "VaR 2 semanas (99%)",
      twoWeeksFivePercent: "VaR 2 semanas (95%)",
      oneMonthOnePercent: "VaR 1 mês (99%)",
      oneMonthFivePercent: "VaR 1 mês (95%)",
    },
    download: {
      tooltip: "Baixar como imagem",
      prompt: {
        downloadPngButton: "Baixar como PNG",
        downloadSvgButton: "Baixar como SVG",
        text: "Escolha o formato em que deseja baixar o componente.",
        title: "Baixar componente",
      },
    },
    portfolioBreakdownOnDate: {
      noDataYet: "Este componente ainda não possui dados.",
    },
    portfolioBreakdownOverTime: {
      noDataYet: "Este componente ainda não possui dados suficientes.",
    },
    statisticsWithPeriods: {
      noStatisticsToDisplay: "Nenhuma estatística para exibir.",
    },
    statistics: {
      noStatisticsToDisplay: "Nenhuma estatística para exibir.",
    },
    operations: {
      statuses: {
        failed: "Falhou",
        pending: "Pendente",
        running: "Em execução",
        succeeded: "Concluído",
      },
    },
  },
  datePickers: {
    datePicker: {
      selectDateTooltip: "Selecionar data",
    },
    dateRangePicker: {
      from: "De (aaaa-mm-dd)",
      fullPeriod: "Período completo",
      to: "Até (aaaa-mm-dd)",
    },
    zoomPicker: {
      fiveYears: "5A",
      fullPeriod: "MAX",
      oneMonth: "1M",
      oneYear: "1A",
      sevenYears: "7A",
      sixMonths: "6M",
      threeMonths: "3M",
      tenYears: "10A",
      threeYears: "3A",
      twoYears: "2A",
      ytd: "YTD",
    },
  },
  dropdowns: {
    iconsDropdown: {
      noIcon: "Sem ícone",
    },
  },
  editPrompt: {
    copyInAllLangs: "Copiar em todos os idiomas",
    editField: "Editar campo",
    enterText: "Insira um texto",
    overwriteDataAllShareClasses: "Substituir dados de todas as classes de ações",
    propertyFilters: {
      title: "Filtros por propriedade",
      tooltip:
        "Para ser considerada, uma posição deve passar por todos os filtros aplicados. Uma posição passa por um filtro se corresponder a qualquer um dos seus valores selecionados.",
      property: "Propriedade",
      values: "Valores",
      empty: "Ainda não há filtros por propriedade.",
      add: "Adicionar filtro por propriedade",
      multiSelect: {
        placeholder: "Selecionar valores",
        selectLabel: "Pressione Enter para selecionar",
        deselectLabel: "Pressione Enter para remover",
        selectedLabel: "Selecionado",
        limitText: (ctx) => `e mais ${ctx.named("count")}`,
      },
    },
    id: "ID",
    idTooltip:
      "Este identificador único serve como referência para o componente dentro da plataforma. Cada componente criado precisa de um identificador distinto. Recomendamos a seguinte convenção para melhor legibilidade: use o título do componente, converta para minúsculas, substitua espaços por hífen. Para um componente intitulado 'Minha Tabela Analítica', o identificador seria 'minha-tabela-analitica'.",
    needUniqueId:
      "O identificador fornecido está sendo usado por outro componente no local atual ou em um vinculado. Por favor, forneça um identificador distinto para garantir a exclusividade.",
    numberOfDecimals: "Número de casas decimais",
    numberOfDecimalsTooltip:
      "O número de casas decimais para todos os números exibidos no componente. Observe que isso não inclui os eixos dos gráficos.",
    withBenchmark: "Mostrar com o benchmark",
    resamplingStrategy: "Estratégia de reamostragem",
    windowHorizon: "Janela deslizante",
    windowHorizonTooltip:
      "A janela deslizante determina o período de 'look-back' utilizado para calcular a volatilidade anualizada em cada ponto do gráfico. Um horizonte mais curto (por exemplo, 3 meses) torna o gráfico muito sensível a choques de mercado e mudanças repentinas de regime, embora possa parecer 'ruidoso' devido a flutuações temporárias. Por outro lado, um horizonte mais longo (por exemplo, 1 ano) fornece uma visão mais suave e estável de riscos a longo prazo, eliminando o ruído de curto prazo do mercado, embora reaja mais lentamente a eventos atuais. Observe que escolher um horizonte mais longo também resulta em uma data de início mais tardia no gráfico, pois o cálculo requer um período histórico completo antes que o primeiro valor possa ser plotado.",
    windowHorizonOptions: {
      threeMonths: "3 meses",
      sixMonths: "6 meses",
      oneYear: "1 ano",
      twoYears: "2 anos",
      threeYears: "3 anos",
      fiveYears: "5 anos",
      sevenYears: "7 anos",
      tenYears: "10 anos",
    },
    timeWindow: "Janela temporal",
    timeWindowOptions: {
      threeMonths: "3 meses",
      sixMonths: "6 meses",
      oneYear: "1 ano",
      twoYears: "2 anos",
      threeYears: "3 anos",
      fourYears: "4 anos",
      fiveYears: "5 anos",
      sixYears: "6 anos",
      sevenYears: "7 anos",
      eightYears: "8 anos",
      nineYears: "9 anos",
      tenYears: "10 anos",
      all: "Tudo",
    },
    valueAtRisk: "Value at risk",
    valueAtRiskOptions: {
      oneDayOnePercent: "VaR 1 dia (99%)",
      oneDayFivePercent: "VaR 1 dia (95%)",
      twoWeeksOnePercent: "VaR 2 semanas (99%)",
      twoWeeksFivePercent: "VaR 2 semanas (95%)",
      oneMonthOnePercent: "VaR 1 mês (99%)",
      oneMonthFivePercent: "VaR 1 mês (95%)",
    },
    footnote: "Texto abaixo do componente",
    placeholderFootnote:
      "Um texto que aparece abaixo do componente. Ex: 'As taxas estão incluídas.'",
    langTabError: "Alguns campos são inválidos nos seguintes idiomas:",
    settingsOnlyUsedOnOverviewTooltip:
      "Esta configuração afeta exclusivamente a vista 'Visão Geral'.",
    startDate: "Data de início",
    startDateTooltip:
      "Selecione uma data de início (no formato AAAA-MM-DD) para o componente. O componente será ajustada automaticamente para exibir dados a partir da data mais antiga disponível para o produto ou da data escolhida, o que for mais recente. Deixar este campo em branco exibirá todos os dados de preço disponíveis para o produto.",
    tabError: "Alguns campos são inválidos",
    title: "Título",
    titleEdit: (ctx) => `Editar ${ctx.named("componentId")}`,
    titleAdd: "Adicionar componente",
    unsavedChangesAlert: "Você tem alterações não salvas. Se sair sem salvar, elas serão perdidas.",
    resamplingStrategyOptions: {
      standard: "Padrão",
      standardTooltip:
        "Ajusta automaticamente o nível de detalhe com base no intervalo de tempo selecionado para manter o gráfico claro e legível.",
      monthly: "Mensal",
      monthlyTooltip: "Mostra o último valor registrado para cada mês no período selecionado.",
    },
    reportFooter: {
      saveSuccess: "O rodapé foi atualizado com sucesso.",
      title: "Rodapé",
      text: "Texto",
      showPageNumber: "Mostrar número da página",
      showFooterLine: "Mostrar linha do rodapé",
      margins: {
        bottom: "Inferior",
        left: "Esquerda",
        right: "Direita",
        title: "Margens (mm)",
      },
    },
    reportHeader: {
      backgroundImage: "Imagem de fundo",
      backgroundImageTooltip:
        "As dimensões do cabeçalho são 794 px de largura e qualquer valor escolhido para a altura (veja abaixo), por isso utilize uma imagem com dimensões que sigam o mesmo rácio para obter o melhor resultado.",
      logo: "Logotipo",
      text: "Texto",
      saveSuccess: "O cabeçalho foi atualizado com sucesso.",
      showDateRange: "Mostrar intervalo de datas",
      textInPrimary: "Texto na cor da marca",
      title: "Cabeçalho",
      useCompanyLogo: "Usar logotipo da empresa",
      logoPosition: {
        left: "Esquerda",
        right: "Direita",
        title: "Posição do logotipo",
      },
      datePosition: {
        bottomLeft: "Inferior esquerdo",
        bottomRight: "Inferior direito",
        centerLeft: "Centro esquerdo",
        centerRight: "Centro direito",
        hidden: "Oculta",
        title: "Posição da data",
        topLeft: "Superior esquerdo",
        topRight: "Superior direito",
      },
      headerVisibility: {
        allPages: "Todas as páginas",
        hidden: "Oculto",
        onlyFirstPage: "Apenas na primeira página",
        title: "Visibilidade do cabeçalho",
      },
      height: {
        title: "Altura",
        large: "Grande (200 px / ~52,90 mm)",
        normal: "Normal (150 px / ~39,67 mm)",
        small: "Pequena (100 px / ~26,45 mm)",
        veryLarge: "Muito grande (250 px / ~66,12 mm)",
      },
      margins: {
        bottom: "Inferior",
        left: "Esquerda",
        right: "Direita",
        top: "Superior",
        title: "Margens (mm)",
        tooltip: "As margens não estão afetando a imagem de fundo.",
      },
      productNamePosition: {
        bottomLeft: "Inferior esquerdo",
        bottomRight: "Inferior direito",
        centerLeft: "Centro esquerdo",
        centerRight: "Centro direito",
        hidden: "Oculto",
        title: "Posição do nome do produto",
        topLeft: "Superior esquerdo",
        topRight: "Superior direito",
      },
      textPosition: {
        bottomLeft: "Inferior esquerdo",
        bottomRight: "Inferior direito",
        centerLeft: "Centro esquerdo",
        centerRight: "Centro direito",
        title: "Posição do texto",
        topLeft: "Superior esquerdo",
        topRight: "Superior direito",
      },
    },
    reportStyle: {
      primaryColor: "Cor primária",
      colorSchemePicker: "Seletor de esquema de cores",
      colorSchemeTooltip:
        "Este esquema de cores é aplicado atualmente aos gráficos de pizza e donut. Se nenhuma cor for fornecida, os gráficos usam por padrão o esquema geral da plataforma.",
      saveSuccess: "O estilo foi atualizado com sucesso.",
      title: "Estilo",
      fontSize: {
        normal: "Normal",
        large: "Grande",
        small: "Pequena",
        title: "Tamanho da fonte",
      },
      margins: {
        left: "Esquerda",
        right: "Direita",
        title: "Margens (mm)",
      },
      spacing: {
        comfortable: "Confortável",
        compact: "Compacto",
        title: "Espaçamento",
      },
      titleBorder: {
        above: "Acima do título",
        below: "Abaixo do título",
        none: "Sem borda",
        title: "Borda do título",
      },
      titlesBold: {
        title: "Títulos dos componentes em negrito",
      },
    },
    genericComponent: {
      addColumn: "Adicionar coluna",
      addRow: "Adicionar linha",
      addData: "Adicionar dados",
      cantChangeType:
        "Você não pode alterar o tipo de um componente genérico depois de salvá-lo. Se deseja um tipo diferente, precisa criar um novo componente genérico.",
      columnWithIndex: (ctx) => `Coluna ${ctx.named("idx")}`,
      data: "Dados",
      date: "Data",
      displayValuesAsPerc: "Apresenta valores como percentagem",
      displayValuesAsPercTooltip: "Apresenta valores com um símbolo '%' no gráfico",
      donutChart: "Gráfico de rosca",
      exampleSector: "Ex: Setores",
      header: "Cabeçalho",
      horizontalBarChart: "Gráfico de barras horizontal",
      key: "Chave",
      image: "Imagem",
      lineChart: "Gráfico de linhas",
      needData:
        "Você não pode salvar um componente genérico sem dados ou com dados parciais. Exclua-o, adicione dados ou complete os dados presentes antes de salvar.",
      pieChart: "Gráfico de pizza",
      removeData: "Remover dados",
      showColumnHeader: "Mostrar cabeçalho da coluna",
      table: "Tabela",
      text: "Texto",
      type: "Tipo",
      value: "Valor",
      verticalBarChart: "Gráfico de barras verticais",
      video: "Vídeo",
      weightPercent: "Peso (em %)",
      lineChartSection: {
        fileMust: "O seu ficheiro deve:",
        selectFile: "Selecionar ficheiro",
        uploadCsv: "Carregue um ficheiro CSV com os seus dados de séries temporais.",
        conditions: {
          dateFormat: "Utilizar o formato de data <strong>YYYY-MM-DD</strong>.",
          dateIncreaseAndUnique: "Conter datas estritamente crescentes e únicas.",
          headerRow:
            "Incluir uma linha de cabeçalho com as colunas <code>date</code> e <code>value</code>.",
          maxPoints:
            "Ter no máximo <strong>500 linhas</strong> e um tamanho de ficheiro inferior a <strong>1&nbsp;MB</strong>.",
          numberFormat:
            "Utilize um ponto (.) como separador decimal e não inclua separadores de milhar.",
        },
        errors: {
          exceedSize: {
            title: "Ficheiro demasiado grande",
            text: "O ficheiro carregado excede 1&nbsp;MB. Limite-o a um máximo de 500 pontos de dados.",
          },
          invalidData: {
            title: "Dados inválidos detetados",
            text: "Algumas linhas contêm valores em falta ou inválidos. Certifique-se de que a coluna <code>date</code> utiliza o formato <strong>YYYY-MM-DD</strong> e que a coluna <code>value</code> contém números válidos.",
          },
          invalidDataSequence: {
            title: "Sequência de datas inválida",
            text: "As datas devem ser estritamente crescentes e únicas. Corrija o ficheiro e tente novamente.",
          },
          parseFail: {
            title: "Falha ao processar",
            text: "O ficheiro CSV não pôde ser lido corretamente. Verifique o formato e tente novamente. Se o problema persistir, contacte a equipa da Alquant.",
          },
          tooManyDataPoints: {
            title: "Demasiados pontos de dados",
            text: "O seu ficheiro contém mais de 500 linhas. Reduza-o para 500 ou menos antes de carregar.",
          },
          unexpectedError: {
            title: "Erro inesperado",
            text: "Ocorreu um erro inesperado ao processar o ficheiro. Por favor, contacte a equipa da Alquant para obter assistência.",
          },
        },
      },
    },
    contacts: {
      addContact: "Adicionar contato",
      contacts: "Contatos",
      contactsPerRow: "Contatos por linha",
      additionalText: "Texto adicional",
      email: "Email",
      exampleEmail: "Ex: jdoe@mail.com",
      exampleName: "Ex: John Doe",
      examplePhone: "Ex: +41 79 123 45 67",
      exampleRole: "Ex: Sócio",
      image: "Imagem",
      name: "Nome",
      phone: "Telefone",
      removeContact: "Remover contato",
      role: "Função",
    },
    dialog: {
      copyInAllLangs: {
        title: "Copiar em todos os idiomas",
        text: "Você vai copiar todos os valores do idioma atual para todos os outros idiomas. Tem certeza?",
      },
      saveFieldInAllShareClasses: {
        title: "Substituir",
        text: "Você vai substituir este campo em todas as outras classes de ações deste produto, não apenas na classe atual. Tem certeza?",
      },
      saveInAllShareClasses: {
        title: "Substituir",
        text: (ctx) =>
          `Você vai substituir os dados de "${ctx.named(
            "tabName"
          )}" de todas as outras classes de ações deste produto pelos dados de "${ctx.named(
            "tabName"
          )}" desta classe de ações. Tem certeza?`,
      },
    },
    description: {
      contentTitle: "Descrição",
    },
    disclaimer: {
      contentTitle: "Aviso legal",
      defaultWarning:
        "Atualmente, você não tem um aviso legal para este produto. Portanto, o aviso padrão foi utilizado. Se você escrever um aviso legal aqui, ele será exibido apenas para este produto.",
    },
    historicalPricesChart: {
      adjusted: "Utilizar preços ajustados",
      adjustedTooltip:
        "Geralmente, os preços ajustados significam preços que são ajustados para dividendos, desdobramentos e outros eventos. O preço não ajustado refere-se simplesmente ao custo de uma ação do produto no final do dia.",
      defaultLogScale: "Por padrão, em escala logarítmica",
      showLogScaleSwitch: "Mostrar alternador de escala logarítmica",
      priceIndexedTo100: "Utilizar preços indexados a 100",
    },
    portfolioBreakdown: {
      cantChangeProperty:
        "Você não pode alterar a propriedade de um componente de posição após salvá-lo. Se quiser uma propriedade diferente, será necessário criar um novo componente.",
      chartType: "Tipo de gráfico",
      displayOrder: "Ordem de exibição",
      donutChart: "Gráfico de rosca",
      horizontalBarChart: "Gráfico de barras horizontal",
      lagRule: "Regra de defasagem dos dados",
      lagRuleTooltip:
        "Escolha quanto deseja atrasar os dados exibidos neste componente. Por exemplo, uma defasagem de dois meses no final do mês significa mostrar os dados mais recentes disponíveis de dois meses atrás. Se hoje for 15 de janeiro de 2025, os dados exibidos serão até 30 de novembro de 2024.",
      pieChart: "Gráfico de pizza",
      property: "Propriedade",
      table: "Tabela",
      verticalBarChart: "Gráfico de barras verticais",
      onlyShowTopThenOthers: {
        title: "Mostrar apenas os principais",
        tooltip:
          'Mostrar apenas os X principais (número escolhido) e mesclar os restantes em "Outros". Deixe em branco para mostrar todos.',
      },
      categoryIdsInOthers: {
        title: 'Elementos a considerar como "Outros"',
        multiSelect: {
          placeholder: "Selecionar elementos",
          selectLabel: "Pressione Enter para selecionar",
          deselectLabel: "Pressione Enter para remover",
          selectedLabel: "Selecionado",
          limitText: (ctx) => `e mais ${ctx.named("count")}`,
        },
      },
      sortOptions: {
        alphabeticallyAscending: "Nome (A → Z)",
        alphabeticallyDescending: "Nome (Z → A)",
        weightAscending: "Peso (baixo → alto)",
        weightDescending: "Peso (alto → baixo)",
      },
      lagRuleOptions: {
        noLag: "Sem defasagem (dados mais recentes)",
        oneMonthEnd: "Fecho do mês anterior",
        twoMonthEnd: "Fecho de há dois meses",
      },
      normalizeBreakdownWeight: "Normalizar pesos",
      normalizeBreakdownWeightTooltip:
        "Quando ativado, os pesos são escalados para somar 100 % em todas as categorias na data selecionada (ou em cada data da série temporal).",
    },
    keyCharacteristics: {
      addKeyCharacteristics: "Adicionar características principais",
      exampleDynamicExposure: "Ex: Exposição dinâmica",
      exampleWeDynamicallyAdapt: "Ex: Adaptamos dinamicamente ...",
      header: "Cabeçalho",
      icon: "Ícone",
      paragraph: "Parágrafo",
      removeKeyCharacteristics: "Remover característica principal",
    },
    biggestDrawdownsTable: {
      numberOfDrawdowns: "Número de perdas máximas",
    },
    stressTestScenariosTable: {
      product: "Produto",
      benchmark: "Benchmark",
      periods: "Períodos",
      addPeriod: "Adicionar período",
      deletePeriod: "Eliminar período",
    },
    liquidityAnalysisTable: {
      customizedTable: "Tabela de visualização",
      holdingsToIgnore: {
        title: "Posições a ignorar",
        holdingsMultiselect: {
          placeholder: "Selecionar participações a ignorar",
          selectLabel: "Pressione Enter para selecionar",
          deselectLabel: "Pressione Enter para remover",
          selectedLabel: "Selecionado",
          limitText: (ctx) => `e mais ${ctx.named("count")}`,
        },
      },
      holdingsToIgnoreContainText: {
        title: "Ignorar participações cujo nome contenha",
        placeholder: "ex. Caixa, Outros",
      },
    },
    liquidityRiskScenarioTable: {
      rowsByTimeBucket: "Dados por tempo até liquidar",
      amountPlaceholder: "Montante (Mio)",
      weightPlaceholder: "Peso (%)",
    },
    monthlyReturnsTable: {
      descending: "Classificar anos em ordem decrescente",
      benchmark: "Benchmark",
      product: "Produto",
      return: "Retorno",
      nameReplacements: "Substituir nomes padrão",
      nameReplacementsTooltip:
        "Personalize os nomes do produto e do benchmark no componente. Deixe em branco para manter os nomes existentes.",
    },
    notify: {
      componentSaveSuccess: (ctx) =>
        `Seu componente '${ctx.named("componentId")}' foi atualizado com sucesso.`,
    },
    overviewHeader: {
      backgroundImage: "Imagem de fundo",
      backgroundImageTooltip:
        "Observe que a imagem atualmente em consideração também é utilizada como a imagem do cartão do produto na página inicial. Consequentemente, qualquer alteração nessa imagem afetará simultaneamente a representação do produto na página inicial.",
      hideProductName: "Ocultar nome do produto",
      text: "Texto",
      textInPrimary: "Texto na cor da marca",
      textTooltip:
        "Observe que o texto atualmente em consideração também é utilizado como o texto do cartão do produto na página inicial. Consequentemente, qualquer alteração nesse texto afetará simultaneamente a representação do produto na página inicial.",
      saveSuccess: "O cabeçalho foi atualizado com sucesso.",
      showDownloadLastFactsheetButton:
        'Mostrar botão "@:components.extras.downloadLastFactsheet.downloadLastFactsheet"',
      showDownloadLastFactsheetButtonTooltip:
        'Para que o botão esteja visível para um usuário, um documento deve ser marcado como "@:pages.products.documents.prompt.uploadFile.shouldConsiderLastFactsheet" na seção "Documentos", e deve estar disponível no idioma selecionado pelo usuário.',
      showFollowButton: "Mostrar botão de seguir",
      title: "Editar cabeçalho de visão geral",
    },
    overviewStyle: {
      colorSchemePicker: "Seletor de esquema de cores",
      colorSchemeTooltip:
        "Este esquema de cores é aplicado atualmente aos gráficos de pizza e donut. Se nenhuma cor for fornecida, os gráficos usam por padrão o esquema geral da plataforma.",
      saveSuccess: "O estilo foi atualizado com sucesso.",
      title: "Estilo",
      titlesBold: {
        title: "Títulos dos componentes em negrito",
      },
    },
    productDetails: {
      addDetail: "Adicionar detalhe",
      exampleIsin: "Ex: ISIN",
      exampleLU: "Ex: LU2220388479",
      key: "Chave",
      noteDragAndDrop: "Nota: Arraste e solte as linhas para reordenar os detalhes.",
      removeDetail: "Remover detalhe",
      showAgio: "Mostrar ágio",
      showAuM: "Mostrar AuM",
      showLastPrice: "Mostrar último preço",
      showIsin: "Mostrar ISIN",
      showTer: "Mostrar TER",
      value: "Valor",
    },
    relativePerformanceChart: {
      footnote: "Nota de rodapé",
      placeholderFootnote:
        "Um texto que aparece abaixo do gráfico. Ex: 'As taxas estão incluídas.'",
    },
    riskProfile: {
      level: "Nível de risco",
    },
    shareClassesTable: {
      bloomberg: "Bloomberg",
      class: "Classe",
      column: "Coluna",
      columnsToShow: "Colunas a exibir",
      showColumn: "Exibir coluna",
      defaultFootnote:
        "SI perf.: os retornos para períodos desde a criação de mais de um ano são anualizados, e não anualizados se menos de um ano.",
      footnote: "Nota de rodapé",
      inceptionDate: "Data de criação",
      isin: "ISIN",
      mgmtFee: "Taxa de gestão",
      minInvestment: "Inv. mín.",
      perfFee: "Taxa de desempenho",
      ter: "TER",
      title: "Editar tabela de classes de ações",
    },
    statistics: {
      benchmark: "Benchmark",
      product: "Produto",
      nameReplacements: "Substituir nomes padrão",
      nameReplacementsTooltip:
        "Personalize os nomes do produto e do benchmark no componente. Deixe em branco para manter os nomes existentes. Por exemplo, use um termo como 'Produto' para abreviar e economizar espaço na exibição.",
      fieldsToDisplay: "Campos a serem exibidos",
      noteDragAndDrop: "Nota: Arraste e solte as linhas para reordenar as estatísticas exibidas.",
      shownStatisticName: "Nome da estatística exibida",
      showStatistic: "Mostrar estatística",
      statisticId: "ID da estatística",
    },
    statisticsWithPeriods: {
      benchmark: "Benchmark",
      product: "Produto",
      nameReplacements: "Substituir nomes padrão",
      nameReplacementsTooltip:
        "Personalize os nomes do produto e do benchmark no componente. Deixe em branco para manter os nomes existentes. Por exemplo, use um termo como 'Produto' para abreviar e economizar espaço na exibição.",
      fieldsToDisplay: "Campos a serem exibidos",
      noteDragAndDrop: "Nota: Arraste e solte as linhas para reordenar as estatísticas exibidas.",
      periodsTitle: "Períodos a serem exibidos",
      shownStatisticName: "Nome da estatística exibida",
      showStatistic: "Mostrar estatística",
      statisticId: "ID da estatística",
      periods: {
        1: "1M",
        3: "3M",
        6: "6M",
        ytd: "YTD",
        12: "1A",
        36: "3A",
        60: "5A",
        84: "7A",
        120: "10A",
        max: "MAX",
      },
    },
    holdingsTable: {
      aggregateHoldings: "Agrupar posições",
      aggregateHoldingsTooltip:
        "Agrega o valor e o peso das posições que tenham o mesmo 'Nome da posição', 'Isin' e 'Moeda'. Todas as outras propriedades são retiradas da posição com o maior peso no grupo. Pode controlar esta agregação em 'Ajustes de dados da posição' → secção 'Substituir', alterando qualquer um destes três campos.",
      fieldsToDisplay: "Campos a serem exibidos",
      lagRule: "Regra de defasagem dos dados",
      lagRuleTooltip:
        "Escolha quanto deseja atrasar os dados exibidos neste componente. Por exemplo, uma defasagem de dois meses no final do mês significa mostrar os dados mais recentes disponíveis de dois meses atrás. Se hoje for 15 de janeiro de 2025, os dados exibidos serão até 30 de novembro de 2024.",
      showHeader: "Mostrar cabeçalho",
      showHoldingsCount:
        "Mostrar « X de Y participações » quando nem todas as participações forem exibidas",
      showTotal: "Mostrar total",
      numHoldings: {
        title: "Número de participações a exibir",
        tooltip:
          "Se você deixar este campo em branco, todos os dados disponíveis para as participações do produto serão exibidos.",
      },
      holdingsToIgnore: {
        title: "Participações a ignorar",
        holdingsMultiselect: {
          placeholder: "Selecionar participações a ignorar",
          selectLabel: "Pressione Enter para selecionar",
          deselectLabel: "Pressione Enter para remover",
          selectedLabel: "Selecionado",
          limitText: (ctx) => `e mais ${ctx.named("count")}`,
        },
      },
      holdingsToIgnoreContainText: {
        title: "Ignorar participações cujo nome contenha",
        placeholder: "ex. Caixa, Outros",
      },
      propertyFilters: {
        property: "Propriedade",
        multiSelect: {
          placeholder: "Selecionar valores",
          selectLabel: "Pressione Enter para selecionar",
          deselectLabel: "Pressione Enter para remover",
          selectedLabel: "Selecionado",
          limitText: (ctx) => `e mais ${ctx.named("count")}`,
        },
      },
      lagRuleOptions: {
        noLag: "Sem defasagem (dados mais recentes)",
        oneMonthEnd: "Fecho do mês anterior",
        twoMonthEnd: "Fecho de há dois meses",
      },
      displayOrder: "Ordem de exibição",
      sortOptions: {
        alphabeticallyAscending: "Nome da participação (A → Z)",
        alphabeticallyDescending: "Nome da participação (Z → A)",
        weightAscending: "Peso (baixo → alto)",
        weightDescending: "Peso (alto → baixo)",
      },
      customizeTable: "Personalizar tabela",
      addColumn: "Adicionar coluna",
      columnWithIndex: (ctx) => `Coluna ${ctx.named("idx")}`,
    },
  },
  extras: {
    changeRoles: {
      changeRoles: "Alterar funções",
      notify: {
        errorText: "Nenhuma função foi atualizada. Motivo: ",
        successText: "Funções do usuário foram atualizadas",
      },
    },
    deleteGenericComponent: {
      delete: "Excluir",
      deleteAllComponents: "Excluir todos os componentes",
      deleteOnlyThisComponent: "Excluir apenas este componente",
      deleting: "Excluindo ...",
      deleteSuccess: "Exclusão bem-sucedida.",
      view: "Vista",
      shareClass: "Classe de ações",
      textIsNotLinked:
        "Você está prestes a excluir permanentemente um componente genérico. Esta ação não pode ser desfeita. Por favor, confirme se deseja prosseguir com a exclusão.",
      textIsLinkedFirstPart:
        "Você está prestes a excluir permanentemente um componente genérico. Esta ação não pode ser desfeita. Observe que este componente está vinculado ao mesmo componente nas seguintes localizações: ",
      textIsLinkedSecondPart:
        "Por favor, confirme se deseja prosseguir com a exclusão e decida se deseja excluir apenas o componente atual ou se deseja excluir este componente e todos os componentes vinculados.",
      title: (ctx) => `Exclusão permanente de ${ctx.named("componentId")}`,
    },
    deleteUser: {
      button: "Excluir",
      dialog: {
        confirm: "Excluir usuário",
        text: "Tem certeza de que deseja excluir permanentemente este usuário?",
        title: "Excluir usuário",
      },
      notify: {
        errorText: "Falha ao excluir o usuário.",
        successText: "Usuário foi excluído.",
      },
    },
    downloadLastFactsheet: {
      downloadLastFactsheet: "Baixar último factsheet",
      downloadingLastFactsheet: "Baixando...",
      needLogin: {
        text: "Para baixar este documento, você precisa estar autenticado.",
        title: "Você precisa estar autenticado",
      },
    },
    manualVerifyEmail: {
      forceVerification: "Forçar verificação de e-mail",
      verified: "E-mail verificado",
      notify: {
        errorText: "A verificação forçada de e-mail falhou.",
        successText: "O e-mail do usuário foi verificado manualmente.",
      },
    },
    riskProfile: {
      higherRisk: "Maior risco",
      lowerRisk: "Menor risco",
    },
  },
  graphs: {
    logScale: "Escala logarítmica",
    notEnoughData:
      "Não há dados suficientes para plotar este gráfico, selecione um intervalo de datas maior.",
    needMoreData:
      "Para calcular essa métrica, é necessário um certo número de dados no início. Aumente o período de tempo para acessar essa métrica.",
  },
  holdingDataAdjustments: {
    categorise: {
      addCategory: {
        button: "Adicionar categoria",
        prompt: {
          category: "Categoria",
          product: "Produto",
          property: "Propriedade",
          title: "Adicionar uma categoria",
          value: "Valor",
          valueAlreadyHasCategory: "Este valor já está atribuído a uma categoria.",
        },
      },
      exportCategories: {
        button: "Exportar categorias como CSV",
        buttonTooltip:
          "Descarregar os mapeamentos de categorias apresentados como um ficheiro CSV.",
      },
      importCategories: {
        button: "Importar categorias de CSV",
        buttonTooltip:
          "Importe um arquivo CSV para atualizar os mapeamentos de categoria em massa.",
        importPrompt: {
          buttonCancel: "Cancelar",
          buttonImport: "Importar",
          text: "Envie um arquivo CSV formatado corretamente para atualizar seus mapeamentos. Recomendamos exportar o mapeamento atual primeiro para verificar a estrutura das colunas. Você pode enviar um arquivo parcial contendo apenas linhas novas ou modificadas; os dados não mencionados não serão alterados.",
          title: "Importar categorias via CSV",
        },
        importErrorsPrompt: {
          close: "Fechar",
          selectErrorType: "Selecione o tipo de erro:",
          title: "Erros de validação de CSV",
          columns: {
            firstRow: "Primeira linha",
            productName: "Nome do produto",
            property: "Propriedade",
            rowIndex: "Índice da linha",
            value: "Valor",
          },
          mismatchedColumn: {
            missingExpectedColumns: "As seguintes colunas obrigatórias estão ausentes:",
            notExpectedColumns: "As seguintes colunas inesperadas foram encontradas:",
            title: "Incompatibilidade de colunas",
            text: 'Certifique-se de que o cabeçalho do CSV contenha as seguintes colunas: "product_name, property, value, category".',
          },
          nonExistentProductName: {
            title: "Nome do produto desconhecido",
            text: "Certifique-se de que todos os nomes dos produtos existam.",
          },
          invalidPropertyForProductName: {
            title: "Propriedade inválida para o produto",
            text: 'Algumas propriedades não estão disponíveis para os produtos selecionados. Remova-as ou verifique-as na aba "Holding Data" na seção "Products" no painel de administração.',
          },
          duplicatedCategory: {
            title: "Categoria duplicada para um valor",
            text: "Remova entradas duplicadas de categoria para o mesmo valor.",
          },
          papaparseMissingQuotes: {
            title: "Aspas não fechadas",
            text: "A análise do CSV falhou porque uma cadeia de texto entre aspas não foi devidamente fechada. Verifique se há aspas de fechamento ausentes nos seus dados.",
          },
          papaparseUndetectableDelimiter: {
            title: "Delimitador indetectável",
            text: "A análise do CSV falhou. Nenhum delimitador comum foi detectado. Certifique-se de que o seu arquivo utiliza apenas um tipo de delimitador, geralmente uma vírgula ou ponto e vírgula.",
          },
          papaparseTooFewFields: {
            title: "Campos insuficientes",
            text: "A análise do CSV falhou. Algumas linhas contêm menos de 4 campos exigidos. Verifique a estrutura do seu arquivo.",
          },
          papaparseTooManyFields: {
            title: "Campos em excesso",
            text: "A análise do CSV falhou. Algumas linhas contêm mais do que os 4 campos esperados. Verifique a estrutura do seu arquivo.",
          },
        },
      },
      saveCategories: {
        button: "Salvar todas as alterações",
        saveSuccess: "Categorias dos dados de holdings salvas com sucesso.",
        updateWarningPrompt: {
          title: "Impacto da gravação das alterações",
          text: "Você está prestes a salvar a categorização após modificar uma ou mais linhas removendo ou atualizando sua categoria. Se as categorias afetadas tiverem traduções salvas, essas traduções poderão ser deletadas — a menos que a categoria ainda exista para o mesmo produto através de outro valor. Além disso, se essas categorias foram usadas para substituir componentes de holdings, essas substituições também serão removidas — a menos que a categoria ainda exista para o mesmo produto através de outro valor.",
        },
      },
    },
    translate: {
      exportTranslations: {
        button: "Exportar traduções como CSV",
        buttonTooltip: "Descarregar os mapeamentos de traduções apresentados como um ficheiro CSV.",
      },
      importTranslations: {
        button: "Importar traduções de CSV",
        buttonTooltip:
          "Importar um arquivo CSV para atualizar os mapeamentos de tradução em massa.",
        importPrompt: {
          buttonCancel: "Cancelar",
          buttonImport: "Importar",
          text: "Envie um arquivo CSV formatado corretamente para atualizar seus mapeamentos. Recomendamos exportar o mapeamento atual primeiro para verificar a estrutura das colunas. Você pode enviar um arquivo parcial contendo apenas linhas novas ou modificadas; os dados não mencionados não serão alterados.",
          title: "Importar traduções via CSV",
        },
        importErrorsPrompt: {
          close: "Fechar",
          selectErrorType: "Selecionar tipo de erro:",
          title: "Erros de validação do CSV",
          columns: {
            firstRow: "Primeira linha",
            language: "Idioma",
            productName: "Nome do produto",
            property: "Propriedade",
            rowIndex: "Índice da linha",
            category: "Categoria",
          },
          mismatchedColumn: {
            missingExpectedColumns: "As seguintes colunas obrigatórias estão ausentes:",
            notExpectedColumns: "As seguintes colunas inesperadas foram encontradas:",
            title: "Incompatibilidade de colunas",
            text: (ctx) =>
              `Certifique-se de que o cabeçalho do CSV contenha as seguintes colunas: ${ctx.named("expectedColumns").join(", ")}.`,
          },
          nonExistentProductName: {
            title: "Nome do produto desconhecido",
            text: "Verifique se todos os nomes dos produtos existem.",
          },
          invalidPropertyForProductName: {
            title: "Propriedade inválida para o produto",
            text: 'Algumas propriedades não estão disponíveis para os produtos selecionados. Remova-as ou revise-as na aba "Holding Data", seção "Produtos", no painel de administração.',
          },
          duplicatedTranslations: {
            title: "Traduções duplicadas para um valor",
            text: "Remova entradas duplicadas de tradução para o mesmo valor.",
          },
          invalidCategoryForProductNameAndProperty: {
            title: "Categoria inválida para propriedade do produto",
            text: "A categoria selecionada não existe para essa propriedade do produto. Verifique as categorias permitidas para a propriedade em questão.",
          },
          invalidTranslationLangForProductName: {
            title: "Idioma indisponível para o produto",
            text: "Você não pode fornecer uma tradução em um idioma que o produto não esteja configurado para usar. Exporte o CSV e verifique uma linha do produto para ver os idiomas disponíveis.",
          },
          papaparseMissingQuotes: {
            title: "Aspas não fechadas",
            text: "A análise do CSV falhou porque uma cadeia de texto entre aspas não foi devidamente fechada. Verifique se há aspas de fechamento ausentes nos seus dados.",
          },
          papaparseUndetectableDelimiter: {
            title: "Delimitador indetectável",
            text: "A análise do CSV falhou. Nenhum delimitador comum foi detectado. Certifique-se de que o seu arquivo utiliza apenas um tipo de delimitador, geralmente uma vírgula ou ponto e vírgula.",
          },
          papaparseTooFewFields: {
            title: "Campos insuficientes",
            text: "A análise do CSV falhou. Cada linha deve ter o mesmo número de colunas que o cabeçalho. Atualmente, algumas linhas têm menos colunas do que o esperado. Verifique a estrutura do seu arquivo.",
          },
          papaparseTooManyFields: {
            title: "Campos em excesso",
            text: "A análise do CSV falhou. Cada linha deve ter o mesmo número de colunas que o cabeçalho. Atualmente, algumas linhas têm mais colunas do que o esperado. Verifique a estrutura do seu arquivo.",
          },
        },
      },
      saveTranslations: {
        button: "Salvar todas as alterações",
        saveSuccess: "Traduções de dados de participações salvas com sucesso.",
      },
    },
    override: {
      exportOverrides: {
        button: "Exportar substituições como CSV",
        buttonTooltip:
          "Descarregar os mapeamentos de substituições apresentados como um ficheiro CSV.",
      },
      importOverrides: {
        button: "Importar substituições de CSV",
        buttonTooltip:
          "Importe um arquivo CSV para atualizar os mapeamentos de substituição em massa.",
        importPrompt: {
          buttonCancel: "Cancelar",
          buttonImport: "Importar",
          text: "Envie um arquivo CSV formatado corretamente para atualizar seus mapeamentos. Recomendamos exportar o mapeamento atual primeiro para verificar a estrutura das colunas. Você pode enviar um arquivo parcial contendo apenas linhas novas ou modificadas; os dados não mencionados não serão alterados.",
          title: "Importar substituições via CSV",
        },
        importErrorsPrompt: {
          close: "Fechar",
          selectErrorType: "Selecionar tipo de erro:",
          title: "Erros de validação do CSV",
          columns: {
            category: "Categoria",
            currency: "Moeda",
            firstRow: "Primeira linha",
            holdingName: "Nome do holding",
            isin: "ISIN",
            productName: "Nome do produto",
            property: "Propriedade",
            rowIndex: "Índice da linha",
          },
          mismatchedColumn: {
            missingExpectedColumns: "As seguintes colunas obrigatórias estão ausentes:",
            notExpectedColumns: "As seguintes colunas inesperadas foram encontradas:",
            title: "Incompatibilidade de colunas",
            text: (ctx) =>
              `Certifique-se de que o cabeçalho do CSV contenha as seguintes colunas: ${ctx.named("expectedColumns").join(", ")}.`,
          },
          unknownProductName: {
            title: "Nome de produto desconhecido",
            text: "Alguns nomes de produto no seu arquivo não correspondem a nenhum produto existente. Verifique se há erros de digitação ou nomes inválidos.",
          },
          invalidPropertyForProductName: {
            title: "Propriedade inválida para o produto",
            text: 'Algumas propriedades não estão disponíveis para os produtos selecionados. Remova ou revise essas propriedades na aba "Dados do Holding" na seção "Produtos" do painel de administração.',
          },
          unknownOverrideCategory: {
            title: "Categoria de substituição desconhecida",
            text: "Um ou mais valores de substituição fazem referência a uma categoria inexistente para o produto e propriedade especificados. Verifique as categorias disponíveis antes de importar.",
          },
          invalidConstituent: {
            title: "Chave de constituinte inválida",
            text: "Algumas linhas fazem referência a constituintes (Nome do produto, Nome do holding, ISIN, Moeda) que não existem. Remova ou corrija essas entradas.",
          },
          duplicateConstituent: {
            title: "Substituições duplicadas",
            text: "Foram encontradas múltiplas substituições para o mesmo constituinte (Nome do produto, Nome do holding, ISIN, Moeda). Mantenha apenas uma entrada por constituinte.",
          },
          papaparseMissingQuotes: {
            title: "Aspas não fechadas",
            text: "A análise do CSV falhou porque uma cadeia de texto entre aspas não foi devidamente fechada. Verifique se há aspas de fechamento ausentes nos seus dados.",
          },
          papaparseUndetectableDelimiter: {
            title: "Delimitador indetectável",
            text: "A análise do CSV falhou. Nenhum delimitador comum foi detectado. Certifique-se de que o seu arquivo utiliza apenas um tipo de delimitador, geralmente uma vírgula ou ponto e vírgula.",
          },
          papaparseTooFewFields: {
            title: "Campos insuficientes",
            text: "A análise do CSV falhou. Cada linha deve ter o mesmo número de colunas que o cabeçalho. Atualmente, algumas linhas têm menos colunas do que o esperado. Verifique a estrutura do seu arquivo.",
          },
          papaparseTooManyFields: {
            title: "Campos em excesso",
            text: "A análise do CSV falhou. Cada linha deve ter o mesmo número de colunas que o cabeçalho. Atualmente, algumas linhas têm mais colunas do que o esperado. Verifique a estrutura do seu arquivo.",
          },
        },
      },
      saveOverrides: {
        button: "Salvar todas as alterações",
        saveSuccess: "Substituições de dados do holding salvas com sucesso.",
      },
    },
  },
  holdingData: {
    others: "Outros",
  },
  images: {
    uploadImage: {
      darkening: "Escurecimento",
      file: "Arquivo",
      noFile: "Nenhum arquivo",
      noImage: "Nenhuma imagem",
      promptTitle: "Carregar nova imagem",
      selectFile: "Selecionar arquivo",
      selectNewImage: "Selecionar nova imagem",
      submit: "Submeter",
      submitting: "A submeter...",
      errorTitleTooLarge: "Imagem muito grande",
      errorMessageTooLarge:
        "A imagem é muito grande. Por favor, selecione outra imagem com tamanho inferior a 30 MB.",
      warningTitleVeryLarge: "Imagem muito grande",
      warningMessageVeryLarge:
        "A imagem é muito grande. Isso tornará as páginas que exibem esta imagem mais lentas para carregar. Para melhor desempenho, recomenda-se usar imagens menores que 10 MB.",
    },
  },
  linkPrompt: {
    componentLinkedTo: "Este componente está vinculado a:",
    currentView: "Vista atual",
    currentShareClass: "Classe de ações atual",
    linkThroughViewsTooltip:
      'Habilitar este recurso cria uma conexão sincronizada entre componentes em várias vistas. Por exemplo, vincular as vistas "Factsheet" e "Visão Geral" garante que qualquer edição em um componente compartilhado seja atualizada simultaneamente em ambas as vistas. Importante: O conteúdo do componente vinculado é duplicado da vista de origem que você está editando no momento. Se você iniciar o vínculo ao editar o componente "descrição" da vista "Factsheet", o componente "descrição" do "Factsheet" será copiado para a "Visão Geral" e, assim, substituirá o componente "descrição" da "Visão Geral".',
    linkThroughShareClassesTooltip:
      'Habilitar este recurso cria uma conexão sincronizada entre componentes em várias classes de ações. Por exemplo, vincular "Minha Classe de Ações A" e "Minha Classe de Ações B" garante que qualquer edição em um componente compartilhado seja atualizada simultaneamente em ambas as classes de ações. Importante: O conteúdo do componente vinculado é duplicado da vista de origem que você está editando no momento. Se você iniciar o vínculo ao editar o componente "descrição" da vista "Minha Classe de Ações A", o componente "descrição" da "Minha Classe de Ações A" será copiado para a "Minha Classe de Ações B" e, assim, substituirá o componente "descrição" da "Minha Classe de Ações B".',
    linkThroughShareClassesForbiddenCrossProductTooltip:
      "Este componente exibe dados de todas as classes de ações, por isso está sempre vinculado a todas as classes de ações do produto. Por esse motivo, não é possível desvincular classes de ações individualmente; apenas links para outras vistas podem ser removidos.",
    linkedWithViews: "Vinculado às seguintes vistas",
    linkedWithShareClasses: "Vinculado às seguintes classes de ações",
    view: "Vista",
    shareClass: "Classe de ações",
    title: (ctx) => `Editar vínculo de ${ctx.named("componentId")}`,
    unlink: "Desvincular",
    unlinking: "Desvinculando ...",
    unsavedChangesAlert: "Você tem alterações não salvas. Se sair sem salvar, elas serão perdidas.",
    confirmSaveDialog: {
      computingNewLinks: "Calculando novos vínculos...",
      onceLinked:
        "Uma vez vinculado, quando uma alteração for aplicada a um componente em qualquer um desses locais (incluindo o atual), todos os outros componentes vinculados serão atualizados da mesma forma. Por favor, confirme se deseja prosseguir com a gravação.",
      overwrittenExistingComponent: "Substituindo um componente com o mesmo id",
      overwrittenExistingComponentTooltip: (ctx) =>
        `Aviso: Já existe um componente com ID '${ctx.named(
          "componentId"
        )}' neste local, portanto ele será substituído por este componente se você vinculá-lo.`,
      title: "Confirmar salvamento de novos vínculos",
      youAreAboutToLink:
        "Você está prestes a vincular o componente atual aos componentes nas seguintes localizações:",
    },
    overviewStyle: {
      title: "Editar os links no estilo da visão geral",
      saveSuccess: "A atualização dos links de estilo foi realizada com sucesso.",
    },
    reportFooter: {
      title: "Editar ligações no rodapé do relatório",
      saveSuccess: "A atualização das ligações de rodapé foi bem-sucedida.",
    },
    reportHeader: {
      title: "Editar ligações no cabeçalho do relatório",
      saveSuccess: "A atualização das ligações do cabeçalho foi bem-sucedida.",
    },
    reportStyle: {
      title: "Editar ligações no estilo do relatório",
      saveSuccess: "A atualização dos links de estilo foi realizada com sucesso.",
    },
    notify: {
      linkSaveSuccess: (ctx) =>
        `A atualização de vínculo de '${ctx.named("componentId")}' foi bem-sucedida.`,
    },
    multiselect: {
      placeholderShareClasses: "Selecione classes de activos para vincular",
      placeholderViews: "Selecione vistas para vincular",
      selectLabel: "Pressione Enter para selecionar",
      deselectLabel: "Pressione Enter para remover",
      selectedLabel: "Selecionado",
    },
    overviewHeader: {
      title: "Editar vínculo do cabeçalho da visão geral",
      saveSuccess: "A atualização de vínculo do cabeçalho foi bem-sucedida.",
    },
  },
  pricesManagement: {
    addData: "Adicionar dados",
    autoDataUpdate: "Seus dados são atualizados automaticamente.",
    date: "Data",
    datePlaceholder: "AAAA-MM-DD",
    dateValidationError: "Você não pode adicionar uma data que já possui um valor.",
    exportCsvButton: "Exportar como CSV",
    importCsvButton: "Importar de CSV",
    launchPriceUpdateButton: "Iniciar atualização",
    launchPriceUpdateTooltip:
      "Ao clicar neste botão, você força uma atualização buscando os dados mais recentes da fonte normalmente usada para a atualização automática diária (se estes dados forem atualizados automaticamente). Os dados podem levar alguns minutos para serem obtidos e atualizados.",
    launchPriceUpdateRunningTooltip: "Os preços estão sendo obtidos no momento.",
    loadingData: "Carregando dados...",
    price: "Preço",
    priceAdj: "Preço (ajustado)",
    priceAdjTooltip:
      "Geralmente, os preços ajustados significam preços que são ajustados para dividendos, desdobramentos e outros eventos. Se não for fornecido, assume-se que é o mesmo que o preço.",
    priceAdjTooltipTable:
      "Geralmente, os preços ajustados significam preços que são ajustados para dividendos, desdobramentos e outros eventos.",
    refreshButton: "Atualizar",
    removeData: "Remover dados",
    benchmarks: {
      noBenchmark: "Nenhum benchmark disponível para este produto.",
    },
    dialog: {
      removeData: {
        title: "Remover um ponto de dados",
        text: "Você está prestes a remover completamente um ponto de dados. Tem certeza?",
      },
    },
    importCsvText: {
      para1:
        "Espera-se que o ficheiro de entrada esteja no formato CSV, com duas ou três colunas e uma linha de cabeçalho.",
      para2:
        "A primeira coluna deve consistir em datas e a segunda coluna deve consistir em números (o preço na data correspondente). A terceira coluna é opcional e, se for fornecida, deve consistir em números correspondentes ao preço ajustado; se não for fornecida, assume-se que os preços ajustados são os mesmos que os preços.",
      para3:
        "Certifique-se de que o seu CSV é válido para evitar quaisquer problemas aquando da leitura e análise dos dados.",
    },
    notify: {
      dateUsedMultipleTimeError:
        "Existem vários preços associados a uma data. Você deve garantir que cada data tenha um preço único atribuído a ela.",
      launchSuccessText:
        "A atualização de preços foi iniciada com sucesso. Atualize em alguns minutos para ver os resultados.",
      launchErrorText: "Erro ao iniciar a atualização de preços, entre em contato conosco.",
      nanFound:
        "Foram encontrados alguns valores vazios. Certifique-se de que todas as linhas e colunas contêm um valor.",
      numberFormatError:
        'Pelo menos um dos números tem um formato não reconhecido. Idealmente, você não deve usar separadores para milhares e usar um ponto como separador decimal, pois este é o formato esperado. Por exemplo, "102.12", "1380.25", "18.952", ...',
      saveErrorText: "Erro ao atualizar os preços, entre em contato conosco.",
      saveSuccessText: "Os preços foram atualizados com sucesso.",
    },
    prompt: {
      addPrice: "Adicionar um preço",
      importCsv: "Importar dados de CSV",
    },
  },
  tables: {
    metricsTable: {
      na: "N/D",
      name: "Nome",
      showLess: "Mostrar menos",
      showMore: "Mostrar mais",
    },
    monthlyReturnsTable: {
      benchmark: "Benchmark",
      return: "Retorno",
    },
    performanceTable: {
      computedFromTo: (ctx) =>
        `Desempenho calculado de ${ctx.named("firstDate")} a ${ctx.named("lastDate")}.`,
      notAvailableData:
        "Dados indisponíveis, seja porque não há dias suficientes para calcular, os dados não são significativos (ex.: sharpe ratio negativo) ou o benchmark não está sempre disponível durante o período selecionado.",
    },
    holdingsTable: {
      noDataYet: "Este componente ainda não possui dados.",
      holdingFields: {
        currency: "Moeda",
        holdingName: "Nome",
        isin: "ISIN",
        value: "Valor",
        weight: "Peso",
      },
      totalOfPortfolio: "Total do portfólio",
      holdingsCountSummary: (ctx) => `${ctx.named("shown")} de ${ctx.named("total")} participações`,
    },
    liquidityAnalysisTable: {
      noDataYet: "Este componente ainda não possui dados.",
      description: "Descrição",
      isin: "ISIN",
      currency: "Moeda",
      aumInLocalCurrency: (ctx) => `AUM (${ctx.named("currency")})`,
      weight: "Peso",
      lessThanOneDay: "0-1 dia",
      twoToSevenDays: "2-7 dias",
      eightToThirtyDays: "8-30 dias",
      thirtyOneToNinetyDays: "31-90 dias",
      ninetyOneToOneHundredEightyDays: "91-180 dias",
      oneHundredEightyOneToThreeHundredSixtyFiveDays: "181-365 dias",
      moreThanThreeHundredSixtyFiveDays: ">365 dias",
      totalOfPortfolio: "Total do portfólio",
    },
  },
  thirdParty: {
    vuePhoneNumberInput: {
      countrySelectorLabel: "Código do país",
      countrySelectorError: "Selecione um país",
      phoneNumberLabel: "Número de telefone",
      example: "Exemplo :",
    },
  },
  videos: {
    uploadVideos: {
      file: "Arquivo",
      noFile: "Nenhum arquivo",
      noVideo: "Nenhuma vídeo",
      selectFile: "Selecionar arquivo",
      selectNewVideo: "Selecionar nova vídeo",
      errorTitleTooLarge: "Vídeo muito grande",
      errorMessageTooLarge:
        "A vídeo é muito grande. Por favor, selecione outra vídeo com tamanho inferior a 30 MB.",
      warningTitleVeryLarge: "Vídeo muito grande",
      warningMessageVeryLarge:
        "A vídeo é muito grande. Isso tornará as páginas que exibem esta vídeo mais lentas para carregar. Para melhor desempenho, recomenda-se usar vídeos menores que 10 MB.",
    },
  },
};
